/* global BigInt */

export const ellipsisString = (str, maxLength) => {
    if (str.length <= maxLength) {
        return str;
    }

    const middle = '...';
    const charsToShow = maxLength - middle.length;
    const frontChars = Math.ceil(charsToShow / 2);
    const backChars = Math.floor(charsToShow / 2);

    return str.substring(0, frontChars) + middle + str.substring(str.length - backChars);
};

export function decodeBase64Value(base64Value) {
    if (!base64Value) return 0;

    const buffer = Buffer.from(base64Value, 'base64');
    const hexValue = buffer.toString('hex');
    const bigIntValue = BigInt(`0x${hexValue}`);

    return bigIntValue.toString(10);
}

export function decodeBase64Value2(base64Value) {
    const bigIntValue = BigInt(`0x${Buffer.from(base64Value, 'base64').toString('hex')}`);
    return bigIntValue.toString(10);
}

export function bigNumberToReadable(bigNumber) {
    // Assurez-vous que c est un tableau non vide
    const c = bigNumber.c && bigNumber.c.length > 0 ? bigNumber.c : [0];

    // Calculez la valeur en utilisant la partie significative (s), l'exposant (e) et le tableau de chiffres (c)
    const value = c[0] * Math.pow(10, bigNumber.e);

    // Appliquez le signe (positif ou négatif)
    return bigNumber.s === -1 ? -value : value;
}

export function handleUnexpectedException(exception) {
    console.error(exception);
}
